jQuery(document).ready(function($){
	var mainHeader = $('.faktotum-auto-hide-header'),
		secondaryNavigation = $('.faktotum-secondary-nav'),
		navTrigger = $('.js-nav-trigger'),
		navWrapper = $('.js-nav-wrapper'),
		//this applies only if secondary nav is below intro section
		belowNavHeroContent = $('.sub-nav-hero'),
		headerHeight = mainHeader.height(),
		menuHasChildren = $('.menu-item-has-children > a'),
		subMenu = $('.sub-menu'),
		menuOpen = false;
	
	//set scrolling variables
	var scrolling = false,
		previousTop = 0,
		currentTop = 0,
		scrollDelta = 10,
		scrollOffset = 150;

	mainHeader.on('click', '.nav-trigger', function(event){
		// $('body').toggleClass('menu-open');
		event.preventDefault();
		navWrapper.toggleClass('menu-open');
		menuOpen = !menuOpen;
	});

	$(document).on('click', function(event) {
        // Check if the navigation is open and the clicked element is not a descendant of navTrigger or navWrapper
        if (menuOpen && !$(event.target).closest(navTrigger).length && !$(event.target).closest(navWrapper).length) {
            navWrapper.removeClass('menu-open');
			menuOpen = false;
        }
    });

	// sub-menu
	menuHasChildren.on('click touch', function(event) {
		event.preventDefault();
		$(this).siblings(subMenu).toggleClass('open');
	});


	// $(window).on('scroll', function(){
	// 	if( !scrolling ) {
	// 		scrolling = true;
	// 		(!window.requestAnimationFrame)
	// 			? setTimeout(autoHideHeader, 250)
	// 			: requestAnimationFrame(autoHideHeader);
	// 	}
	// });

	$(window).on('resize', function(){
		headerHeight = mainHeader.height();
	});

	function autoHideHeader() {
		var currentTop = $(window).scrollTop();

		( belowNavHeroContent.length > 0 ) 
			? checkStickyNavigation(currentTop) // secondary navigation below intro
			: checkSimpleNavigation(currentTop);

	   	previousTop = currentTop;
		scrolling = false;
	}

	function checkSimpleNavigation(currentTop) {
		//there's no secondary nav or secondary nav is below primary nav
	    if (previousTop - currentTop > scrollDelta) {
	    	//if scrolling up...
	    	mainHeader.removeClass('is-hidden');
	    } else if( currentTop - previousTop > scrollDelta && currentTop > scrollOffset) {
	    	//if scrolling down...
	    	mainHeader.addClass('is-hidden');
	    }
	}

	function checkStickyNavigation(currentTop) {
		//secondary nav below intro section - sticky secondary nav
		var secondaryNavOffsetTop = belowNavHeroContent.offset().top - secondaryNavigation.height() - mainHeader.height();
		
		if (previousTop >= currentTop ) {
	    	//if scrolling up... 
	    	if( currentTop < secondaryNavOffsetTop ) {
	    		//secondary nav is not fixed
	    		mainHeader.removeClass('is-hidden');
	    		secondaryNavigation.removeClass('fixed slide-up');
	    		belowNavHeroContent.removeClass('secondary-nav-fixed');
	    	} else if( previousTop - currentTop > scrollDelta ) {
	    		//secondary nav is fixed
	    		mainHeader.removeClass('is-hidden');
	    		secondaryNavigation.removeClass('slide-up').addClass('fixed'); 
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	}
	    	
	    } else {
	    	//if scrolling down...	
	 	  	if( currentTop > secondaryNavOffsetTop + scrollOffset ) {
	    		mainHeader.addClass('is-hidden');
	    		secondaryNavigation.addClass('fixed slide-up');
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	} else if( currentTop > secondaryNavOffsetTop ) {
	    		//once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset 
	    		mainHeader.removeClass('is-hidden');
	    		secondaryNavigation.addClass('fixed').removeClass('slide-up');
	    		belowNavHeroContent.addClass('secondary-nav-fixed');
	    	}

	    }
	}
});